import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './distribuidoraForm';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoTela, initForm, salvar, excluir, getLista, getListaCidade } from './distribuidoraActions';
import ColorUtils from '../common/colorUtils/ColorUtils';

class Distribuidora extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
		this.props.getLista();
		this.props.getListaCidade();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Nome</Th>
								<Th alignCenter>Cidade</Th>
								<Th alignCenter>Custo</Th>
								<Th alignCenter>Localização</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome} ${item.nome_cidade}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									backgroundColor={item.cor} color={ColorUtils.getCorFonte(item.cor)} >
									<Td>{item.nome}</Td>
									<Td alignCenter>{item.nome_cidade}</Td>
									<Td alignCenter>{FormatUtils.formatarValorTela(item.custo_operacao, 4)}</Td>
									<Td alignCenter>
										{(item.latitude && item.longitude) &&
										<a
											href={`https://www.google.com/maps?q=${item.latitude},${item.longitude}`}
											target="_blank"
											rel="noopener noreferrer"
											title="Abrir no Google Maps"
											style={{
												display: 'inline-flex',
												alignItems: 'center',
												justifyContent: 'center',
												width: 32,
												height: 32,
												borderRadius: '50%',
												backgroundColor: '#e0f2fe',
												color: '#1d4ed8',
												fontSize: 16,
												textDecoration: 'none',
												transition: '0.2s',
											}}
											onMouseOver={(e) => {
												e.currentTarget.style.backgroundColor = '#1d4ed8';
												e.currentTarget.style.color = '#fff';
											}}
											onMouseOut={(e) => {
												e.currentTarget.style.backgroundColor = '#e0f2fe';
												e.currentTarget.style.color = '#1d4ed8';
											}}
										>
											<i className="fas fa-map-marker-alt"></i>
										</a>}
									</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4)
												});
												this.props.initForm({
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4)
												});
												this.props.initForm({
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.distribuidora,
	modoTela: state.distribuidora.modoTela,
	lista: state.distribuidora.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaCidade }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Distribuidora);
